import { VyTextarea, type VyTextareaProps } from '@vy/ui-design-system';
import { isEmptyString } from '@vy/utils';
import { Controller, type FieldPath, type FieldValues } from 'react-hook-form';
import { useFieldController } from './useFieldController';

export type VyTextareaFieldProps<TForm extends FieldValues> = Omit<
  VyTextareaProps,
  'value' | 'onChange' | 'onBlur' | 'error' | 'helperText' | 'inputRef'
> & {
  name: FieldPath<TForm>;
  helperText?: string;
};

export function VyTextareaField<TForm extends FieldValues>({
  name,
  helperText,
  ...rest
}: VyTextareaFieldProps<TForm>) {
  const { control, message } = useFieldController<TForm>(name);
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <VyTextarea
          {...rest}
          data-field-span="full"
          value={field.value ?? ''}
          // '' must persist as undefined: optional schema fields reject empty strings.
          onChange={(event) => field.onChange(isEmptyString(event.target.value) ? undefined : event.target.value)}
          onBlur={field.onBlur}
          inputRef={field.ref}
          error={Boolean(message)}
          helperText={message ?? helperText}
        />
      )}
    />
  );
}
